module.exports = "/_next/static/videos/skiing-1-3148dea589938b60d2f11f4ec37c109b.webm";